<script>
    import {ICONS} from '$m7-library/component/Icons/IconDatabase.js';

    const {
        name,
        class: className = '',
        style = '',
        role = 'img',
        'aria-label': ariaLabel = name
    } = $props();
</script>

<!--
  1. We look up the icon code from our database.
  2. We pass that code into an inline style using a CSS Custom Property.
-->
<i
        style:--icon-content="'{ICONS[name]}'"
        class={className}
        style={style}
        role={role}
        aria-label={ariaLabel}
>
</i>

<style>
    /* This is the *only* style rule you need.
      It will be injected into the Shadow DOM by Svelte.
    */
    i::before {
        /* 1. It reads the CSS variable provided by the inline style. */
        content: var(--icon-content);

        /* 2. It uses the globally loaded font-family.
           (This assumes your global @font-face rule defines 'YourIconFont')
        */
        font-family: 'm7' !important;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>

